//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { FileParameter } from './models/FileParameter';
import type { FinancialRequestCount } from './models/FinancialRequestCount';
import type { FinancialRequestDetailed } from './models/FinancialRequestDetailed';
import type { FinancialRequestSummaryPaginationResult } from './models/FinancialRequestSummaryPaginationResult';
import { FinancialSortingSource } from './models/FinancialSortingSource';
import type { RightToSeeFinancialRequest } from './models/RightToSeeFinancialRequest';
import type { SaveFinancialRequest } from './models/SaveFinancialRequest';
import type { SaveFinancialResponse } from './models/SaveFinancialResponse';
import { SortDirection } from './models/SortDirection';
import { UploadFileType } from './models/UploadFileType';
import { Utilities } from './Utilities';

export class FinancialRequestsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        hasRightToSeeFinancialRequests: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/financial-requests/{siren}/authorization';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitFinancialRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/financial-requests/{siren}/submit';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getFinancialRequestsCount: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/financial-requests/{siren}/count';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getFinancialRequests: (
			siren: string,
			skip?: number,
			take?: number,
			sortDirection?: SortDirection,
			sortSource?: FinancialSortingSource,
        ): string => {
            let clientRequestUrl = '/api/v1/financial-requests/{siren}/list?';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            if (skip === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('skip'));
            } else if (skip !== undefined) {
                clientRequestUrl += `skip=${encodeURIComponent(String(skip))}&`;
            }
            if (take === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('take'));
            } else if (take !== undefined) {
                clientRequestUrl += `take=${encodeURIComponent(String(take))}&`;
            }
            if (sortDirection === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('sortDirection'));
            } else if (sortDirection !== undefined) {
                clientRequestUrl += `sortDirection=${encodeURIComponent(String(sortDirection))}&`;
            }
            if (sortSource === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('sortSource'));
            } else if (sortSource !== undefined) {
                clientRequestUrl += `sortSource=${encodeURIComponent(String(sortSource))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getFinancialRequest: (
			siren: string,
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/financial-requests/{siren}/requests/{id}';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        uploadFile: (
			type?: UploadFileType,
			requestId?: string,
        ): string => {
            let clientRequestUrl = '/api/v1/financial-requests/upload-file?';
            if (type === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('type'));
            } else if (type !== undefined) {
                clientRequestUrl += `type=${encodeURIComponent(String(type))}&`;
            }
            if (requestId === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('requestId'));
            } else if (requestId !== undefined) {
                clientRequestUrl += `requestId=${encodeURIComponent(String(requestId))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Check if user has right to see financial requests for given siren
     * @return OK
     */
    async hasRightToSeeFinancialRequests(
        siren: string,
    ): Promise<RightToSeeFinancialRequest> {
        const clientRequestUrl = this.baseUrl + this.routes.hasRightToSeeFinancialRequests(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<RightToSeeFinancialRequest>(_response, false, []);
    }

    /**
     * Submit financial request
     * @param body (optional) 
     * @return OK
     */
    async submitFinancialRequest(
        siren: string,
        body?: SaveFinancialRequest,
    ): Promise<SaveFinancialResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.submitFinancialRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SaveFinancialResponse>(_response, false, []);
    }

    /**
     * Get amount of request
     * @return OK
     */
    async getFinancialRequestsCount(
        siren: string,
    ): Promise<FinancialRequestCount> {
        const clientRequestUrl = this.baseUrl + this.routes.getFinancialRequestsCount(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<FinancialRequestCount>(_response, false, []);
    }

    /**
     * Get list of request
     * @param skip (optional) 
     * @param take (optional) 
     * @param sortDirection (optional) 
     * @param sortSource (optional) 
     * @return OK
     */
    async getFinancialRequests(
        siren: string,
        skip?: number,
        take?: number,
        sortDirection?: SortDirection,
        sortSource?: FinancialSortingSource,
    ): Promise<FinancialRequestSummaryPaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getFinancialRequests(
            siren,
            skip,
            take,
            sortDirection,
            sortSource,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<FinancialRequestSummaryPaginationResult>(_response, false, ['requestCreationDate']);
    }

    /**
     * Get request detailed
     * @return OK
     */
    async getFinancialRequest(
        siren: string,
        id: number,
    ): Promise<FinancialRequestDetailed> {
        const clientRequestUrl = this.baseUrl + this.routes.getFinancialRequest(
            siren,
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<FinancialRequestDetailed>(_response, false, ['requestCreationDate', 'birthDate', 'endValidityDate']);
    }

    /**
     * Submit financial request file
     * @param type (optional) 
     * @param requestId (optional) 
     * @param fileToUpload (optional) 
     * @return No Content
     */
    async uploadFile(
        type?: UploadFileType,
        requestId?: string,
        fileToUpload?: FileParameter,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.uploadFile(
            type,
            requestId,
        );

        const content = new FormData();
        if (fileToUpload === null || fileToUpload === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('fileToUpload'));
        } else {
            content.append('fileToUpload', fileToUpload.data, fileToUpload.fileName ? fileToUpload.fileName : 'fileToUpload');
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }
}
